<template>
	<div class="home">
		<b-card>
			<h2>Syllabus Generator</h2>
			<p>Fill in the form below to start creating a new syllabus, or <span class="load-text" @click="openLoadDialog">click here to load a previously created syllabus.</span></p>
			<p v-if="$route.meta.advanced"><span style="" class="load-text" @click="load_syllabus_data(); $router.push('/');">Click here to create a new syllabus</span></p>
			<p style="font-style: italic; font-size: 9pt;">Note: Syllabi are stored locally in your web browser.  If you clear your browsing data, <b>they will be lost forever</b>.  To prevent this, please use <b>Export Syllabus Data</b> to save your syllabus data to your computer and make sure to back it up.</p>
			<b-card>
				<router-view :load_syllabus_data="load_syllabus_data" :active_syllabus="active_syllabus"/>
			</b-card>
			
			<b-modal ref="loadModal" title="Load Syllabus">
				<b-container v-if="loadable.length > 0">
					<b-row style="box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4); height: 60px;" v-for="(v, key) in loadable" :key="key">
						<b-col style="height: 100%;">
							<div style="height: 100%; display: flex; flex-direction: column; justify-content: center;">
								<div style="width: 100%;position: relative; margin: auto;" class="load-text" @click="$router.push(`/${v.file_name}`); $refs.loadModal.hide()">{{v.course_title}}</div>
							</div>
						</b-col>
						<b-col style="height: 100%;" cols="3">
							<b-btn @click="deleteFile(v.file_name)" style="height: 90%; top: 5%; display: block; position: absolute; left: auto; right: 0px;" variant="danger">Delete</b-btn>
						</b-col>
					</b-row>
				</b-container>
				<p v-else>
					You don't have any saved syllabi.  Please create one, or import one from a .syl file.
				</p>
				<template slot="modal-footer" slot-scope="{ cancel }">
					<b-btn variant="primary" @click="$refs.loadFromFile.show()">Import from File</b-btn>
					<b-btn @click="cancel">Cancel</b-btn>
				</template>
			</b-modal>
			<b-modal ref="loadFromFile" title="Import Syllabus from File">
				<load-from-file ref="uploadComponent"/>
				<template slot="modal-footer" slot-scope="{ cancel }">
					<b-btn :disabled="!$refs.uploadComponent || !$refs.uploadComponent.isValidFile" variant="primary" @click="save_syllabus($refs.uploadComponent.loadedContents); $router.push(`/${$refs.uploadComponent.loadedContents.file_name}`); $refs.loadFromFile.hide(); $refs.loadModal.hide()">Import</b-btn>
					<b-btn @click="cancel">Cancel</b-btn>
				</template>
			</b-modal>
		</b-card>
	</div>
</template>

<script>
import LoadFromFile from '@/components/LoadFromFile'
export default {
	name: 'home',
	components: {
		LoadFromFile
	},
	data(){
		return {
			class_day_text: ["M", "T", "W", "Th", "F"],
			active_syllabus: {
				initialized: false,
				file_name: "",
				course_title: "",
				course_number: "",
				course_location : "",
				course_instructor: "",
				course_tas: "",
				start_date: "",
				end_date: "",
				start_time: "",
				end_time: "",
				class_days: [true,false,true,false,true],
				class_day_data: [],
				sections: []
			},
			loadable: []
		}
	},
	methods: {
		loadList(){
			this.loadable.length = 0;
			for (var i = 0; i < localStorage.length; i++){
				let key = localStorage.key(i);
				if (key.startsWith('syllabus_'))
				{
					let parsed = JSON.parse(localStorage.getItem(key));
					this.loadable.push({file_name: parsed.file_name, course_title: parsed.course_title, start_date: parsed.start_date});
				}
			}
		},
		deleteFile(file){
			localStorage.removeItem(file);
			this.loadList()
		},
		openLoadDialog()
		{
			this.loadList()
			this.$refs.loadModal.show();
		},
		save_syllabus(data){
			console.log(data)
			if (!data.file_name)
				return;
			localStorage.setItem(data.file_name, JSON.stringify(data))
		},
		load_syllabus_data(data){
			if (data == null)
			{
				data = {
					initialized: false,
					file_name: "",
					course_title: "",
					course_number: "",
					course_location : "",
					course_instructor: "",
					course_tas: "",
					start_date: "",
					end_date: "",
					start_time: "",
					end_time: "",
					class_days: [true,false,true,false,true],
					class_day_data: [],
					sections: []
				}
				let date = new Date();
				data.file_name = `syllabus_${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`;
				data.start_date = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
				data.end_date = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
			}
			this.$set(this, "active_syllabus", data)
		}
	},
	mounted(){
		if (!this.active_syllabus.initialized)
			this.load_syllabus_data();
	}
}
</script>

<style lang="scss" scoped>
.home
{
	margin-top: 50px;
	margin-bottom: 50px;
	margin-left: 10%;
	margin-right: 10%;
}

.load-text
{
	transition: 200ms;
	color: #00806E;
	font-weight: 600;
}

.load-text:hover
{
	transition: 200ms;
	color: #0AA590;
	cursor: pointer;
}
</style>
